import React, { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Modal, Button, Form, Row, Col, ListGroup } from 'react-bootstrap';
import api from "../axiosConfig";
import './CalendarStyles.css';

const CalendarView = () => {
  const [citas, setCitas] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [citasDelDia, setCitasDelDia] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState('');



  // Cargar citas desde backend
  const fetchCitas = async () => {
    try {
      const response = await api.get('/citas/');
      const citasData = response.data.resultados.map(cita => {
        const clienteNombre = cita.cliente
          ? `${cita.cliente.nombres || ""} ${cita.cliente.apellidos || ""}`.trim()
          : 'Sin nombre';

        return {
          id: cita.id,
          start: `${cita.fecha}T${cita.hora}`,
          fecha: cita.fecha,
          hora: cita.hora,
          title: `Cliente: ${clienteNombre}`,
          extendedProps: {
            cliente_id: cita.cliente_id,
            cliente_nombre: clienteNombre,
            motivo_id: cita.motivo_id,
          },
        };
      });
      setCitas(citasData);
    } catch (error) {
      console.error('Error al cargar citas:', error);
    }
  };

 

  useEffect(() => {
    fetchCitas();
    
  }, []);

  // Click en día del calendario
  const handleDateClick = (info) => {
    const dia = info.dateStr;
    const citasDelDia = citas
      .filter(cita => cita.fecha === dia)
      .filter(cita => cita.title.toLowerCase().includes(filtro.toLowerCase()));
    setCitasDelDia(citasDelDia);
    setFechaSeleccionada(dia);
    setShowModal(true);
  };

  // Filtrado de citas
  const citasFiltradas = citas.filter(cita =>
    cita.title.toLowerCase().includes(filtro.toLowerCase())
  );

  return (
    <div className="p-3">

      {/* Filtro */}
      <Row className="mb-3">
        <Col md={4}>
         <h5
  className="mb-2 p-2 text-white rounded text-center"
  style={{
    background: "linear-gradient(90deg, #007bff, #28a745)", // azul → verde
  }}
>
  Gestor de Citas - Calendario
</h5>
          <Form.Control
            type="text"
            placeholder="Buscar por nombre de cliente..."
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </Col>
      </Row>

      {/* Calendario */}
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth',
        }}
        events={citasFiltradas.map(cita => ({
          start: cita.fecha,
          display: 'background', // eventos fantasma para conteo
        }))}
        dateClick={handleDateClick}
        height="auto"
        themeSystem="bootstrap"
      
        dayCellContent={(arg) => {
          const citasDia = citasFiltradas.filter(c => c.fecha === arg.dateStr);
          return (
            <div style={{ position: 'relative', textAlign: 'center', paddingTop: 2 }}>
              <span>{arg.dayNumberText}</span>
              {citasDia.length > 0 && (
                <span
                  style={{
                    position: 'absolute',
                    bottom: 2,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    fontSize: '10px',
                    fontWeight: '600',
                    color: '#000',
                    backgroundColor: 'rgba(255,255,255,0.7)',
                    borderRadius: 4,
                    padding: '0 4px',
                  }}
                >
                  {citasDia.length === 1 ? '1 cita' : 'Hay citas'}
                </span>
              )}
            </div>
          );
        }}
      />

      {/* Modal con citas del día */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Citas del {fechaSeleccionada}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {citasDelDia.length === 0 ? (
            <p>No hay citas este día.</p>
          ) : (
            <ListGroup>
              {citasDelDia.map(cita => (
                <ListGroup.Item
                  key={cita.id}
                  className="fc-event" // Mantiene tus colores
                  style={{ marginBottom: '2px' }}
                >
                  {cita.hora} - {cita.extendedProps.cliente_nombre}
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CalendarView;
